import { Dialog, DialogTitle, DialogDescription, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { Input } from '@/components/catalyst-ui/input'
import { Field, Label } from '@/components/catalyst-ui/fieldset'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function EditRegistrantContactDialog({
  open,
  onClose,
  domainName,
  address,
  onAddressChange,
  onSave,
  isLoading = false,
}) {
  if (!address) return null

  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl p-5 !bg-[#FAFAFA]">
      <div className="flex items-center justify-between">
        <DialogTitle className="!text-lg !font-semibold !text-[#09090B]">Edit Registrant Contact</DialogTitle>
        <button
          onClick={onClose}
          className="text-black hover:text-zinc-600 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#A1A1AA]">
          Update the registrant contact information for {domainName}
        </DialogDescription>
        <form className="space-y-3 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <Field>
              <Label className="text-sm font-medium text-gray-700">First Name</Label>
              <Input
                type="text"
                value={address.firstName || ''}
                onChange={(e) => onAddressChange({...address, firstName: e.target.value})}
              />
            </Field>
            <Field>
              <Label className="text-sm font-medium text-gray-700">Last Name</Label>
              <Input
                type="text"
                value={address.lastName || ''}
                onChange={(e) => onAddressChange({...address, lastName: e.target.value})}
              />
            </Field>
          </div>
          <Field>
            <Label className="text-sm font-medium text-gray-700">Address Line 1</Label>
            <Input
              type="text"
              value={address.address1 || ''}
              onChange={(e) => onAddressChange({...address, address1: e.target.value})}
            />
          </Field>
          <div className="grid grid-cols-2 gap-4">
            <Field>
              <Label className="text-sm font-medium text-gray-700">City</Label>
              <Input
                type="text"
                value={address.city || ''}
                onChange={(e) => onAddressChange({...address, city: e.target.value})}
              />
            </Field>
            <Field>
              <Label className="text-sm font-medium text-gray-700">State</Label>
              <Input
                type="text"
                value={address.state || ''}
                onChange={(e) => onAddressChange({...address, state: e.target.value})}
              />
            </Field>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Field>
              <Label className="text-sm font-medium text-gray-700">Postal Code</Label>
              <Input
                type="text"
                value={address.postalCode || ''}
                onChange={(e) => onAddressChange({...address, postalCode: e.target.value})}
              />
            </Field>
            <Field>
              <Label className="text-sm font-medium text-gray-700">Country</Label>
              <Input
                type="text"
                value={address.country || ''}
                onChange={(e) => onAddressChange({...address, country: e.target.value})}
              />
            </Field>
          </div>
          <Field>
            <Label className="text-sm font-medium text-gray-700">Phone</Label>
            <Input
              type="tel"
              value={address.phone || ''}
              onChange={(e) => onAddressChange({...address, phone: e.target.value})}
            />
          </Field>
          <Field>
            <Label className="text-sm font-medium text-gray-700">Email</Label>
            <Input
              type="email"
              value={address.email || ''}
              disabled
              className="!bg-gray-100 !text-gray-500 cursor-not-allowed"
            />
          </Field>
        </form>
      </DialogBody>
      <DialogActions className="!mt-4 !flex !flex-col sm:!flex-row !gap-3">
        <Button 
          onClick={onClose}
          outline
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          Cancel
        </Button>
        <Button 
          onClick={onSave}
          color="dark"
          disabled={isLoading}
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
